import { AuthContextService } from 'Public_old/src/app/Services/authContext.service';
import { GeneralService } from 'Public_old/src/app/Services/general.service';
import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceGateway } from '@components/device_gateway.component';
import { createRoot, Root } from 'react-dom/client';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'reactVisitsComponent';

@Component({
	standalone: false,
	selector: 'device-gateway-component',
	template: ` <div class="wrapper-container" #${containerElementName}></div> `,
	encapsulation: ViewEncapsulation.None,
})
export class DeviceGatewayWrapperComponent implements OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(
		private readonly ngZone: NgZone,
		private readonly authContextService: AuthContextService,
		private readonly generalService: GeneralService,
		private readonly router: Router,
	) {}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private setLanguage(languageCode: string): void {
		localStorage.setItem('languageCode', languageCode);

		if (this.authContextService.isSignedIn()) {
			this.generalService.setlanguage(languageCode).subscribe(
				() => {
					window.location.reload();
				},
				// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
				() => {},
			);
		} else {
			window.location.reload();
		}
	}

	private blockRouteOnMobileWeb(): boolean {
		const currentUrl = this.router.url;

		if (/dropin/.test(currentUrl)) {
			return true;
		}

		return false;
	}

	private async render() {
		const shouldBlockRouteOnMobile = this.blockRouteOnMobileWeb();
		if (shouldBlockRouteOnMobile) return;

		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const forwardChangeLanguage = (code) => {
			this.ngZone.run(() => {
				this.setLanguage(code);
			});
		};
		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper>
					<DeviceGateway __TEMP__changeLanguage={forwardChangeLanguage} />
				</CellulaProviderWrapper>,
			);
		});
	}
}
